/** @jsxImportSource @gasman/smush */

import './new_song.css';

import { Component } from '@gasman/smush';

class NewSongView extends Component {
    constructor(app) {
        super();

        this.app = app;
    }

    render(container) {
        let engineList = <table class="engine-list"></table>;

        container.appendChild(
            <div class="new-song">
                <h2>New song</h2>
                {engineList}
            </div>,
        );

        this.app.engines.forEach((engine) => {
            let row = (
                <tr>
                    <td>
                        <button>{engine.displayName}</button>
                    </td>
                    <td>{engine.description}</td>
                </tr>
            );
            let button = row.querySelector('button');
            button.addEventListener('click', () => {
                this.app.openNewSong(engine.name);
            });
            engineList.appendChild(row);
        });
    }
}

export { NewSongView };
